window.Reverb = window.Reverb || {};
Reverb.BundledCheckout = Reverb.BundledCheckout || {};

Reverb.BundledCheckout.DiscountCodes = (function () {
  let thisContainer;

  const errorsContainerSelector = '[data-discount-code-errors-container]';
  const applyLinkSelector = 'a[data-discount-code-button]';
  const inputSelector = 'input[data-discount-code]';

  const urlDataAttribute = 'url';
  const paymentMethodDataAttribute = 'payment-method';

  function init(container) {
    thisContainer = container;
    bindFieldChange();
  }

  function bindFieldChange() {
    $(thisContainer).on('click', applyLinkSelector, applyDiscountCode);
    $(thisContainer).on('keydown', inputSelector, (e) => {
      if (e.keyCode == 13) {
        applyDiscountCode(e);
      }
    });
  }

  function applyDiscountCode(e) {
    e.preventDefault();

    const discountCode = $(inputSelector).val();
    if (discountCode.length === 0) {
      return;
    }

    const url = thisContainer.data(urlDataAttribute);
    const paymentMethod = thisContainer.data(paymentMethodDataAttribute);

    const request = $.ajax({
      url,
      type: 'POST',
      data: { discount_code: discountCode, payment_method: paymentMethod },
      dataType: 'json',
    });

    request.done((response, statusText, xhr) => {
      const container = $(errorsContainerSelector);
      if (response.redirect) {
        window.location = response.redirect;
      } else {
        container.html(response.message);
      }
    });
  }

  function doUnlessJavascriptResponse(xhr, fn, context) {
    if (xhr.getResponseHeader('content-type').indexOf('javascript') === -1) {
      fn.call(context, xhr);
    }
  }

  return {
    init,
  };
}());

$(() => {
  Reverb.BundledCheckout.DiscountCodes.init($('[data-discount-code-container]'));
});



// WEBPACK FOOTER //
// ./src/components/legacy/bundled_checkout/discount_codes.js